var _path, _rect, _path2, _path3, _path4, _rect2, _rect3, _rect4, _path5, _path6, _path7, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApp = function SvgApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 202 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 23H67v133h68V23Z",
    fill: "#E1DFDA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 138,
    width: 71,
    height: 17,
    rx: 2,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.462 28.074c.021-6.104-4.932-11.058-11.036-11.038l-53.982.174c-6.053.02-10.953 4.926-10.965 10.98l-.234 121.757c-.011 6.096 4.936 11.039 11.032 11.021l53.793-.154c6.048-.017 10.947-4.914 10.968-10.962l.424-121.778ZM73.78 155.117a5 5 0 0 1-5.012-4.993l-.153-121.33a5 5 0 0 1 5-5.007H84.51a6.948 6.948 0 0 0 6.949 6.948h20.443a6.948 6.948 0 0 0 6.949-6.948h9.754a5 5 0 0 1 5 4.994l.153 121.194a5 5 0 0 1-4.988 5.006l-54.99.136Z",
    fill: "#002A1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m106.281 56.598-35.265.087L71 50.07l35.265-.087.016 6.615ZM137 54V36a2 2 0 1 1 4 0v18a2 2 0 1 1-4 0ZM62 82v-9a2 2 0 1 1 4 0v9a2 2 0 1 1-4 0ZM62 67v-9a2 2 0 1 1 4 0v9a2 2 0 1 1-4 0ZM127.643 62.165l-56.637.14L71 60.07l56.638-.14.005 2.235ZM94.798 43.316l-23.792.06L71 41.14l23.793-.059.005 2.235Z",
    fill: "#002A1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m127.263 37.012-20.29.05a4.974 4.974 0 0 0 .025 9.947l20.29-.05a4.973 4.973 0 1 0-.025-9.947Z",
    fill: "#5C8283"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 68,
    width: 61,
    height: 21,
    rx: 2,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 91,
    width: 61,
    height: 21,
    rx: 2,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 114,
    width: 61,
    height: 21,
    rx: 2,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m115.33 149-28.33.07.004 1.5 28.33-.07-.004-1.5Z",
    fill: "#002A1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.997 86.968A3.011 3.011 0 0 0 90 83.948l-.032-10.945A3.011 3.011 0 0 0 86.948 70l-10.945.032A3.011 3.011 0 0 0 73 73.052l.032 10.945A3.011 3.011 0 0 0 76.052 87l10.945-.032Zm-11.543-2.97-.032-10.947c0-.323.258-.58.58-.58l10.947-.033c.323 0 .58.258.58.581l.033 10.946a.579.579 0 0 1-.581.581l-10.946.032a.59.59 0 0 1-.581-.58ZM86.997 109.968A3.01 3.01 0 0 0 90 106.949l-.032-10.946A3.011 3.011 0 0 0 86.948 93l-10.945.032A3.011 3.011 0 0 0 73 96.052l.032 10.945a3.011 3.011 0 0 0 3.02 3.003l10.945-.032Zm-11.543-2.971-.032-10.946c0-.323.258-.58.58-.58l10.947-.033c.323 0 .58.258.58.581l.033 10.946a.579.579 0 0 1-.581.581l-10.946.032a.589.589 0 0 1-.581-.581ZM86.997 132.968A3.01 3.01 0 0 0 90 129.949l-.032-10.946a3.011 3.011 0 0 0-3.02-3.003l-10.945.032A3.01 3.01 0 0 0 73 119.051l.032 10.946a3.011 3.011 0 0 0 3.02 3.003l10.945-.032Zm-11.543-2.971-.032-10.946c0-.323.258-.581.58-.581l10.947-.032c.323 0 .58.258.58.581l.033 10.946a.579.579 0 0 1-.581.581l-10.946.032a.589.589 0 0 1-.581-.581Z",
    fill: "#5C8283"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 74.5,
    width: 8,
    height: 8,
    rx: 4,
    stroke: "#5C8283"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 97.5,
    width: 8,
    height: 8,
    rx: 4,
    stroke: "#5C8283"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 120.5,
    width: 8,
    height: 8,
    rx: 4,
    stroke: "#5C8283"
  })));
};
export default SvgApp;